import { ScheduleManager } from "./ScheduleManager";

import store from "../../store/store";

// Tools
const ft = require("../Tools/FileTools");

/**
 * The object will load the schedule file and make it ready to be read by the schedule manager
 */
export class ScheduleLoader {
  constructor(pathToScheduleFile, userInfo, preview, alertProject = null) {
    this.userInfo = userInfo;
    this.preview = preview;
    this.pathToScheduleFile = pathToScheduleFile;
    this.pathToReadFile = store.state.config.dirs.app + "temp/readingDirectory/";
    this.pathToPreviewReadFile =
      store.state.config.dirs.root + "temp/" + userInfo.socId + "/" + userInfo.userId + "/readingPreview/";
    this.alertProject = alertProject;
  }

  /**
   * Main method, call it to process the loading. Returns the scheduleManager, ready to be read
   */
  make() {
    let path = this.pathToReadFile;
    let preview = false;
    if (this.preview) {
      path = this.pathToPreviewReadFile;
      preview = true;
    }

    if (this.alertProject != null) {
      path = this.alertProject;
    }

    return ft
      .read(path + "scheduleManager.json")
      .then((response) => {
        return new ScheduleManager(response.schedulesReader, path, preview, this.alertProject != null);
      })
      .catch((err) => {
        console.error(err);
        return null;
      });
  }
}
